<template>
  <el-dialog
    title="编辑"
    :visible.sync="dialogVisible"
    width="60%"
    v-dialogdrag
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <avue-form
      :option="option"
      v-model="form"
      :upload-error="uploadError"
      :upload-delete="uploadDelete"
      :upload-before="uploadBefore"
      :upload-after="uploadAfter"
    >
      <template slot="role">
      <el-select v-model="form.role" multiple placeholder="请选择">
        <el-option
                v-for="item in role"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :disabled="item.state == 2 ? true : false">
        </el-option>
      </el-select>
    </template>
      <template slot="phone">
        <input
          class="el-input__inner"
          style="height: 32px"
          placeholder="请输入 联系电话"
          maxlength="11"
          type="tel"
          v-model="form.phone"
          pattern="[0-9]"
          onkeyup="value=value.replace(/[\W]/g,'')"
          onbeforepaste="clipboardData.setData('text',clipboardData.getData('text').replace(/[^\d]/g,''))"
        />
      </template>
    </avue-form>
    <span slot="footer" class="dialog-footer">
      <el-button
        icon="el-icon-circle-check"
        type="primary"
        size="small"
        @click="handleSubmit(form)"
        >修 改</el-button
      >
      <el-button icon="el-icon-circle-close" size="small" @click="handleClose"
        >取 消</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {actionUrl, imageUrl} from "@/config/public";
import {userUpdate, userView} from "@/api/system/index";

export default {
  name: "edit",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    choiceId: String,
  },
  data() {
    return {
      role: this.$store.state.system.role,
      form: {},
      option: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: "头像",
            type: "upload",
            listType: "picture-img",
            tip: '只能上传jpg/png',
            span: 14,
            accept: 'image/*',
            row: true,
            prop: "headPortrait",
            loadText: "附件上传中，请稍等",
            propsHttp: {
              res: "data",
              url: "url",
              name: "path",
              home: imageUrl,
            },
            headers: {
              Authorization: this.$store.state.user.Token,
            },
            action: actionUrl,
            rules: [
              {
                required: true,
                message: "请上传头像",
                trigger: "blur",
              },
            ],
          },
          {
            label: "昵称",
            prop: "fullName",
            maxlength: 20,
            showWordLimit:true,
            rules: [
              {
                required: true,
                message: "请输入昵称",
                trigger: "blur",
              },
            ],
          },
          {
            label: "联系电话",
            prop: "phone",
            slot: true,
            rules: [
              {
                required: true,
                message: "请输入联系电话",
                trigger: "blur",
              },
            ],
          },
          {
            label: "所属角色",
            prop: "role",
            type: "select",
            dicData: this.$store.state.system.role,
            span: 12,
            multiple: true,
            props: {
              label: "name",
              value: "id",
            },
          },
          {
            label: "状态",
            prop: "state",
            type: "radio",
            dicData: [
              { label: "启用", value: 1 },
              { label: "禁用", value: 2 },
            ],
            rules: [
              {
                required: true,
                message: "请选择状态",
                trigger: "blur",
              },
            ],
          },
          {
            label: "审核权限",
            prop: "auditPermission",
            type: "radio",
            dicData: [
              { label: "开启", value: 1 },
              { label: "关闭", value: 0 },
            ],
            rules: [
              {
                required: false,
                message: "请选择审核权限",
                trigger: "blur",
              },
            ],
          },
        ],
      },
    };
  },
  mounted() {
    userView(this.choiceId).then((res) => {
      this.form = {
        ...res.data,
        auditPermission: res.data.auditPermission
            || 0,
      };
    });
  },
  methods: {
    /**
     * 删除上传文件确认
     * @returns {Promise}
     */
    uploadDelete() {
      return this.$confirm(`是否确定移除？`);
    },

    /**
     * 上传前处理文件对象
     * @param {File} file - 待上传的文件
     * @param {Function} done - 放行回调
     * @returns {void}
     */
    uploadBefore(file, done) {
      var newFile = new File([file], file.name, { type: file.type });
      done(newFile);
    },

    /**
     * 上传失败回调
     * @param {Error|string} error - 错误信息
     * @param {Object} column - 字段配置
     * @returns {void}
     */
    uploadError(error, column) {
      this.$message.error(error);
    },

    /**
     * 上传成功回调
     * @param {Object} res - 上传响应数据
     * @param {Function} done - 完成回调
     * @returns {void}
     */
    uploadAfter(res, done) {
      done();
      this.$nextTick(() => {
        this.form.image = res.image;
        this.form.headPortrait = res.path;
      });
    },

    /**
     * 关闭编辑弹窗
     * @returns {void}
     */
    handleClose() {
      this.$root.eventHub.$emit("changeEdit", false);
    },

    /**
     * 提交修改员工信息
     * @param {Object} form - 表单数据
     * @returns {boolean|void}
     */
    handleSubmit(form) {
      if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(form.phone)) {
        this.$message.error('手机号错误')
        return false;
      }
      userUpdate({
        id: form.id,
        fullName: form.fullName,
        headPortrait: form.headPortrait,
        phone: form.phone,
        state: form.state,
        auditPermission: form.auditPermission ,
        roleIds: form.role.toString(),
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success("修改成功");
          this.$root.eventHub.$emit("changeEdit", true);
        }
      });
    },
  },
};
</script>

<style scoped>
</style>
